import type { FC } from 'react';
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Flex,
  Skeleton,
  Text,
} from '@eqi-investimentos/react';
import { CTA_Button } from '@/modules/Content/interface/CTA_Button';
import { Program } from '@/modules/Entertainment/interface/Program';
import { CTAButton } from '@/modules/Content/ui/CTAButton';
import { IfRender } from '@/utils/jsx';
import { truncateString } from '@/utils/string';

export const InfoData: FC<InfoDataProps> = ({
  dataCTAProgram,
  isEqi,
  program,
  isLoading,
}) => {
  return (
    <Flex flexDir="column" w="full" maxW="55.25rem" gap="l">
      <Flex direction="column" w="full" gap="2xs">
        <IfRender condition={!!isLoading}>
          <Skeleton w="13.75rem" h="32px" />
          <Skeleton w="7.5rem" h="28px" />
        </IfRender>
        <IfRender condition={!isLoading}>
          <Flex justifyContent="space-between">
            <Flex flexDirection="column">
              <Text size="h5" fontWeight="mediium">
                {program?.title}
              </Text>
              <Text size="xl" color="content.brand">
                {!program?.other_authors.length
                  ? program?.author?.name
                  : program?.other_authors
                      .map((author) => author.name)
                      .join(', ')}
              </Text>
            </Flex>
            {isEqi && !!dataCTAProgram?.data && (
              <Flex h="3.25rem">
                <CTAButton data={dataCTAProgram.data} />
              </Flex>
            )}
          </Flex>
        </IfRender>
      </Flex>
      <IfRender condition={!!isLoading}>
        <Skeleton w="55.25rem" h="7.5rem" mt="2rem" />
      </IfRender>
      <IfRender condition={!isLoading && !!program!.description_striped}>
        <Accordion
          allowToggle
          bg="background.brandLight"
          borderRadius="xs"
          p="l"
        >
          <AccordionItem border="none">
            <AccordionButton
              _expanded={{ display: 'none' }}
              style={{ alignItems: 'flex-start' }}
              p="0"
            >
              <Text size="xl" textAlign="left">
                {truncateString(program!.description_striped || '', 150)}
              </Text>
              <AccordionIcon color="content.primary" />
            </AccordionButton>
            <AccordionButton
              _expanded={{
                display: 'flex !important',
                justifyContent: 'flex-end',
                marginBottom: '-20px',
              }}
              style={{ display: 'none' }}
              p="0"
            >
              <AccordionIcon color="content.primary" />
            </AccordionButton>
            <AccordionPanel
              sx={{
                padding: '0 !important',
                color: 'content.primary',
                p: {
                  fontSize: 'xl',
                  lineHeight: 'xl',
                },
                'strong,b': {
                  fontWeight: 'semibold',
                },
                a: {
                  color: 'content.brand',
                },
                'h1,h2,h3,h4,h5,h6': {
                  fontSize: '2xl',
                  fontWeight: 'semibold',
                },
              }}
              dangerouslySetInnerHTML={{ __html: program!.description || '' }}
            />
          </AccordionItem>
        </Accordion>
      </IfRender>
    </Flex>
  );
};

interface InfoDataProps {
  dataCTAProgram?: CTA_Button;
  isEqi: boolean;
  program?: Program;
  isLoading?: boolean;
}
